export const getPersonalAccidentState = (state) => state?.personalAccident;
